export default {
      id: "action-icon-order-confirmation-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-order-confirmation",
      toString: function () {
        return this.url;
      }
    }